import React from "react";
import { Button, Checkbox, FormControlLabel, MenuItem, Select, Stack, Typography } from "@mui/material";

import { getMissingStatusChoices } from "../../../services/missingReports";
import MissingRetailerLookupFilter from "./MissingRetailerLookupFilter";

export const DEFAULT_MISSING_SORT_OPTIONS = [
  { value: "updated_desc", label: "Updated (newest)" },
  { value: "updated_asc", label: "Updated (oldest)" },
  { value: "created_desc", label: "Created (newest)" },
  { value: "created_asc", label: "Created (oldest)" },
  { value: "retailer_asc", label: "Retailer (A-Z)" },
  { value: "retailer_desc", label: "Retailer (Z-A)" },
];

export const PRODUCT_OVERRIDES_MISSING_SORT_OPTIONS = [
  { value: "created_desc", label: "Created (newest)" },
  { value: "created_asc", label: "Created (oldest)" },
  { value: "override_name_asc", label: "Override Name (A-Z)" },
  { value: "override_name_desc", label: "Override Name (Z-A)" },
  { value: "retailer_asc", label: "Retailer (A-Z)" },
  { value: "retailer_desc", label: "Retailer (Z-A)" },
];

const formatStatusLabel = (value) => {
  if (!value || typeof value !== "string") return value;
  return value
    .split("_")
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ");
};

const MissingReportsToolbar = ({
  status,
  onStatusChange,
  retailerId,
  retailerLabel,
  onRetailerChange,
  includeMissingUnknownRetailers,
  onIncludeMissingUnknownRetailersChange,
  sortBy,
  onSortChange,
  sortOptions = DEFAULT_MISSING_SORT_OPTIONS,
  csvUrl,
}) => (
  <Stack direction="row" spacing={1} sx={{ mb: 2 }} alignItems="center" flexWrap="wrap">
    <Typography sx={{ fontSize: "0.8rem" }}>Status:</Typography>
    <Select
      size="small"
      value={status}
      onChange={(event) => {
        onStatusChange(event.target.value);
      }}
    >
      <MenuItem value="all">All</MenuItem>
      {getMissingStatusChoices().map((value) => (
        <MenuItem key={value} value={value}>
          {formatStatusLabel(value)}
        </MenuItem>
      ))}
    </Select>
    <MissingRetailerLookupFilter
      retailerId={retailerId}
      retailerLabel={retailerLabel}
      onRetailerChange={onRetailerChange}
    />
    <FormControlLabel
      control={
        <Checkbox
          size="small"
          checked={includeMissingUnknownRetailers}
          onChange={(event) => {
            onIncludeMissingUnknownRetailersChange(event.target.checked);
          }}
        />
      }
      label="Missing/unknown retailers"
      sx={{ ml: 0.5 }}
    />
    <Typography sx={{ fontSize: "0.8rem", ml: 1 }}>Sort:</Typography>
    <Select
      size="small"
      value={sortBy}
      onChange={(event) => {
        onSortChange(event.target.value);
      }}
    >
      {sortOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
    <Button
      variant="outlined"
      size="small"
      disabled={!csvUrl}
      onClick={() => {
        window.open(csvUrl, "_blank", "noopener,noreferrer");
      }}
    >
      Download CSV
    </Button>
  </Stack>
);

export default MissingReportsToolbar;
